module.exports = __webpack_public_path__ + "img/auto_parts.71f70bcf.svg";